export default "__VITE_ASSET__d462b78d__"